module.exports = __webpack_public_path__ + "static/media/mavRav.03c7c3cc.svg";